import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import swal from "sweetalert";

const Educational = () => {
  const [inputList, setInputList] = useState([
    { degree: "", institute: "", subject: "" },
  ]);

  const [degree, setDegree] = useState("");
  const [institute, setInstitute] = useState("");
  const [subject, setSubject] = useState("");
  const [allDegree, setAllDegree] = useState([]);
  const [infoBuffer, setInfoBuffer] = useState(false);
  const [data, setData] = useState(true);

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleAddClick = () => {
    setInputList([...inputList, { degree: "", institute: "", subject: "" }]);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  useEffect(() => {
    axios.get(`/api/user_info`).then((res) => {
      setData(false);
      if (res.status === 200) {
        setDegree(res.data?.users?.user_info?.edu_level);
        setInstitute(res.data?.users?.user_info?.institute);
        setSubject(res.data?.users?.user_info?.subject);
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`/api/user/educationlavel`).then((res) => {
      setData(false);
      if (res.status === 200) {
        setAllDegree(res.data.education);
      }
    });
  }, []);

  const educationHandle = (e) => {
    // alert('ok');
    e.preventDefault();
    setInfoBuffer(true);
    const formData = new FormData();

    formData.append("edu_level", degree);
    formData.append("institute", institute);
    formData.append("subject", subject);
    //add member to group
    axios.post(`/api/user/educational/store`, formData).then((res) => {
      setInfoBuffer(false);
      if (res.data.status === 200) {
        swal("Operation Successful", res.data.message, "success");
      }
    });
  };
  return (
    <>
      <form onSubmit={educationHandle}>
        <div className="row col-md-12 mx-md-2 justify-content-center">
          <h5 className="text-light text-left">Educational Information</h5>
          <div className="under-line-x mb-3 mt-1"></div>
        </div>
        <center>
          <div className="row col-sm-12 col-md-12 col-lg-10 ">
            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Degree</div>
              <div>&nbsp;:</div>
            </div>

            <div className="col-sm-12 col-md-8 mb-3">
              <select
                className="form-control form-control-sm account-input-style"
                onChange={(e) => setDegree(e.target.value)}
                value={degree}
              >
                <option value="">Select Your Degree</option>
                {allDegree &&
                  allDegree.map((item) => (
                    <option value={item.name} selected={item.name === degree}>
                      {" "}
                      {item.name}{" "}
                    </option>
                  ))}
              </select>
            </div>

            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Institute</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3">
              <input
                onChange={(e) => setInstitute(e.target.value)}
                value={institute}
                placeholder="Enter your institute"
                className="from-control w-100 custom-con-input form-control-sm "
              />
            </div>

            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Subject</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3">
              <input
                onChange={(e) => setSubject(e.target.value)}
                value={subject}
                className="from-control w-100 custom-con-input form-control-sm "
                placeholder="Enter your Subject"
              />
            </div>
          </div>

          <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
            <div></div>
            <div></div>
          </div>
          <div className="col-sm-12 col-md-8 mb-3 justify-content-center my-3 ">
            <div className="col-md-4">
              {data ? (
                <>
                  <button className="form-control form-control-sm account-input-style">
                    <i className="fas fa-spinner fa-pulse"></i>
                  </button>
                </>
              ) : (
                <button className="btn BTnInfo w-100 fw-bold" type="submit">
                  {infoBuffer ? (
                    <>
                      <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                    </>
                  ) : (
                    <></>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </center>
      </form>
    </>
  );
};

export default Educational;
